import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { I18nModule } from '@spartacus/core';
import { PageLayoutModule, OutletModule, OutletRefModule, PageSlotModule, MediaModule } from '@spartacus/storefront';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { KbRegisterComponent } from './kb-register.component';
import { RECAPTCHA_SETTINGS, RecaptchaFormsModule, RecaptchaModule, RecaptchaSettings } from 'ng-recaptcha';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { GeneralConditionsComponent } from './general-conditions/general-conditions.component';
import { DataProtectionComponent } from './data-protection/data-protection.component';
import { SoldToInfoComponent } from './sold-to-info/sold-to-info.component';
import { EnvironmentService } from 'src/app/services/environment.service';

@NgModule({
  imports: [
    CommonModule,
    PageLayoutModule,
    OutletModule,
    OutletRefModule,
    PageSlotModule,
    I18nModule,
    MediaModule,
    FormsModule,
    ReactiveFormsModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
  ],
  providers: [
    {
      provide: RECAPTCHA_SETTINGS,
      useFactory: (config: EnvironmentService): RecaptchaSettings => {
        return { siteKey: config.getConfig().googleReCaptchaKey };
      },
      deps: [EnvironmentService],
    },
  ],
  declarations: [KbRegisterComponent, GeneralConditionsComponent, DataProtectionComponent, SoldToInfoComponent],
})
export class KbRegisterModule {}
